require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ultras-y-drakas-todo-menos-futbol.json") })
        }
      }, "path---ultras-y-drakas-todo-menos-futbol");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ultras-y-drakas-todo-menos-futbol!./.cache/json/ultras-y-drakas-todo-menos-futbol.json
// module id = 449
// module chunks = 231608221292675